import {ReactNode} from 'react';

const CCard = ({ content }: { content: ReactNode }) => {
  return <div className="c-card">{content}</div>;
};

export default CCard;
